import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useAppSelector } from '../../hooks';
import {
    ConnectionDot,
    connectionStatusConfig,
} from '../inopack-app-bar/connection-status-indicator';

// Short, drawer-friendly text per status (the full explanation stays in the
// app-bar tooltip; here we have room for a plain label instead).
const drawerLabel = {
    connected: 'En línea',
    connecting: 'Reconectando…',
    disconnected: 'Sin conexión',
} as const;

export const ConnectionStatusListItem = () => {
    const status = useAppSelector((state) => state.connectionStatus.status);
    const { color, pulsing } = connectionStatusConfig[status];

    return (
        <ListItem dense>
            <ListItemIcon sx={{ minWidth: 0, mr: 2, ml: '6px' }}>
                <ConnectionDot color={color} pulsing={pulsing} />
            </ListItemIcon>
            <ListItemText>{drawerLabel[status]}</ListItemText>
        </ListItem>
    );
};
